/**
 * useDockPin — V5.1+cockpit Dock pin engine
 * Persists last-active view-mode chip to localStorage.
 * Source: plan/ALIGNMENT-DELTAS.md Delta 1 (DockPinEngine)
 */
import { useCallback, useEffect, useState } from 'react';

const KEY = 'freshcards:dockPin';

export function useDockPin(chipId: string) {
  const [isPinned, setIsPinned] = useState<boolean>(() => {
    try { return localStorage.getItem(KEY) === chipId; } catch { return false; }
  });

  const pin = useCallback(() => {
    try { localStorage.setItem(KEY, chipId); } catch { /* ignore */ }
    setIsPinned(true);
  }, [chipId]);

  const unpin = useCallback(() => {
    try { localStorage.removeItem(KEY); } catch { /* ignore */ }
    setIsPinned(false);
  }, []);

  // Cross-tab sync
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === KEY) setIsPinned(e.newValue === chipId);
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [chipId]);

  return { isPinned, pin, unpin };
}

export function getPinnedChipId(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}
